<template>
    <LayoutSub className="offline">
        <SubpageTitleContainer :title="$t('offline.title')"
            :subText="`카드 단말기, 포스 시스템이 설치된 가맹점 네트워크와 카드사, 은행 등과 대외 인터페이스를 연결하는 VAN 시스템을 통해 <br />부가가치를 창출하는 차별화된 서비스를 제공하는 금융 플랫폼입니다.`">
            <RedLineButton :type="`inbound`" :text="`부가서비스`" />
            <RedLineButton :type="`outbound`" :text="`자료다운로드`" />
        </SubpageTitleContainer>

        <SubSection class="grid-3 pt-0 scroll" data-aos="fade-up">
            <CardBox :idx="1" :title="`기술을 선도하는 기업`" :list="[
                '국내 최초 신용카드 결제서비스',
                '국내 최초 신용카드대금 자동이체 서비스',
                '국내 최초 부산 하나로 교통카드 서비스',
                '국내 최초 전자서명 서비스',
                '업계 최초 코스닥 등록',
            ]" />
            <CardBox :idx="2" :title="`가장 안전한 시스템`" :list="[
                '최첨단 IDC 센터 및 최적의 보안 시스템 구축',
                '업계 최초로 시스템 및 서버 이중화로 최고의 안전성 제공',
                '365일 24시간 실시간 모니터링을 통한 무장애 실현',
                '차세대 시스템 구축을 통한 시스템 최적화',
            ]" />
            <CardBox :idx="3" :title="`최고 성능의 단말기`" :list="[
                `업계 유일 기술연구소 운영`,
                `자체 개발한 하드웨어와 소프트웨어로 자유로운 커스터마이징 가능 `,
                `국내최초 IC 카드 인증 획득 (EMV Level 1, 2)`,
                `국내최초 RF 카드 인증 획득<br />(Visa Paywave, Mastercard paypass)`,
                `엄격한 해외 인증 획득 (PCI PED 2.0)`,
            ]" />
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">기본 기능</SubTitle3>
            <div class="image-list-wrap">
                <ImageListItem data-aos="fade-up" title="카드 결제" desc="마그네틱, IC 등 카드 종류와 상관 없이 안전한 결제를 지원합니다."
                    src="sub01_01.png" />
                <ImageListItem data-aos="fade-up" title="멤버십 카드 포인트"
                    desc="통신 3사, OK캐쉬백을 포함한 다양한 제휴 멤버십부터 가맹점에서 발급한 자체 포인트까지 이지체크를 통해 편리하게 처리하고 관리할 수 있습니다."
                    src="sub01_02.png" />
                <ImageListItem data-aos="fade-up" title="영수증 발급"
                    desc="별다른 가입절차 없이 국세청 현금영수증 (소비자소득공제,사업자지출증빙)을 발행할 수 있으며 일반 영수증도 편리하게 출력할 수 있습니다."
                    src="sub01_03.png" />
                <ImageListItem data-aos="fade-up" title="매출 집계" desc="결제수단별, 일자별 등 원하는 조건으로 집계된 매출 데이터 확인이 가능합니다."
                    src="sub01_04.png" />
            </div>
        </SubSection>
        <SubSection class="offline03">
            <SubTitle3 listStyle="dot">지원하는 간편결제</SubTitle3>
            <div class="easy-payment-list">
                <ImgBorderBox src="npay.png" />
                <ImgBorderBox src="kakaopay.png" />
                <ImgBorderBox src="samsungpay.png" />
                <ImgBorderBox src="applepay.png" />
                <ImgBorderBox src="payco.png" />
                <ImgBorderBox src="tosspay.png" />
                <ImgBorderBox src="skpay.png" />
                <ImgBorderBox src="lpay.png" />
            </div>
        </SubSection>
        <SubSection class="pb-0">
            <SubTitle3 class="mb-32" listStyle="dot">이지체크 모바일(EasyCheck Mobile)</SubTitle3>
            <SubParagraph1 class="pl-30 c-black3">이지체크 모바일과 모바일 기기를 연동하여 매장을 쉽고 편리하게 관리할 수 있습니다.</SubParagraph1>
            <div class="mt-60" data-aos="fade-up">
                <TableRow :title="`편리한 사용`"
                    :content="`이지체크 모바일은 스마트폰 앱 실행시 결제가 가능하며, 배터리 소모를 줄이기 위하여 일정 시간 사용하지 않으면 자동으로 OFF 되어 간편합니다. <br />(ED-944 모델은 휴대폰 연결에 따라 자동으로 ON/OFF)`"
                    :src="`sub01_icon01.png`" />
                <TableRow :title="`IC 우선 거래 지원`" :content="`여신금융협회에 등록된 보안 인증 단말기로 신용카드 단말기 정보보호 기술 기준에 적합한 제품입니다.`"
                    :src="`sub01_icon02.png`" />
                <TableRow :title="`강력한 보안`" :content="`리딩한 카드 정보를 암호화하여 전송하기 때문에 고객의 소중한 정보를 안전하게 보호할 수 있습니다.`"
                    :src="`sub01_icon03.png`" />
            </div>
            <div class="grid-3 mt-60">
                <CardBox2 data-aos="fade-up" :title="`EasyCheck IC App`" :links="[
                    'https://play.google.com/store/apps/details?id=kr.co.kicc.ecm&hl=ko',
                    'https://apps.apple.com/kr/app/easycheckic/id1043451429',
                ]">
                </CardBox2>
                <CardBox2 data-aos="fade-up" :title="`EasyCheckTablet <br />(EasyCheckPad)`" :list="[
                    '앱카드 결제 가능 (바코드, QR코드 인식 가능)',
                    '상품정보가 태블릿 메모리에만 저장됨 <br />(앱 삭제 시 상품 정보 초기화)  ',
                ]" :links="[
                    'https://play.google.com/store/apps/details?id=kr.co.kicc.ectablet&hl=ko',
                    'https://apps.apple.com/kr/app/easycheck-pad/id1470356711',
                ]">
                </CardBox2>
                <CardBox2 data-aos="fade-up" :title="`EasyCheck Mobile 2.0C`" :list="[
                    '상품 관리 및 상품 결제 가능',
                    '앱카드 결제 가능 (바코드, QR코드 인식 가능)',
                    '포인트 복합 결제 가능',
                    '상품 정보가 서버에 저장되어 인터넷 관리자 프로그램<br />(ASP)과 연동됨',
                ]" :links="[
                    'https://play.google.com/store/apps/details?id=kr.co.kicc.ecm2&hl=ko',
                    'https://apps.apple.com/kr/app/easycheck-mobile-2-0c/id1046787916',
                ]">
                </CardBox2>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox from '@/components/CardBox.vue';
import CardBox2 from '@/components/CardBox2.vue';
import ImageListItem from '@/components/ImageListItem.vue';
import ImgBorderBox from '@/components/ImgBorderBox.vue';
// import RedLineButton from '@/components/RedLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubParagraph1 from '@/components/SubParagraph1.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow from '@/components/TableRow.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        // RedLineButton,
        CardBox,
        ImageListItem,
        SubTitle3,
        ImgBorderBox,
        SubParagraph1,
        TableRow,
        CardBox2,
        SubSection,
    },
};
</script>
<style lang="scss" scoped></style>
